import { A } from '@adornis/base/env-info.js';
import { Entity } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { _subscribeCurrentUser, currentUser, updateCurrentUser } from '@adornis/users/client/currentUser.js';
import { loginWithToken } from '@adornis/users/db/a-user.js';
import { filter, firstValueFrom } from 'rxjs';
import { User } from './user.js';

@Entity()
export class RegistrationConfirmationCode extends AdornisEntity {
  static override _class = 'RegistrationConfirmationCode';

  static async loginWithOTP(otp: string, email?: string, userID?: string): Promise<User> {
    if (!A.isClient) throw new Error('Can only be used in client context');
    const { validateOTP } = await import('../api/RegistrationConfirmationCode.js');
    const loginToken = await validateOTP(otp, email, userID)();
    const [authenticatedUserID, userClass] = await loginWithToken(loginToken)();
    updateCurrentUser(undefined, false);
    await _subscribeCurrentUser({ userID: authenticatedUserID, userClass });
    return firstValueFrom(currentUser<User>().whenReady.pipe(filter(Boolean)));
  }
}
